// In USER_GUIDED summaries, bold (**...**) marks the spans that came from the user's own notes.
//
// Simple ** pair matching; misses spans containing a literal '*'. Fine for the saturation cap and
// trend metrics — swap in a real markdown parse if precision ever matters.
export const SUMMARY_BOLD_SPAN = /\*\*([^*]+?)\*\*/g

export type SummaryBoldMeasurement = {
  spans: string[]
  // Fraction of the content's characters that sit inside **...** spans, in [0, 1].
  boldRatio: number
}

/** Measures a summary's **...** bold coverage — the shared basis for the saturation cap and the bold-drift telemetry. */
export function measureSummaryBold(markdown: string): SummaryBoldMeasurement {
  const spans = markdown.match(SUMMARY_BOLD_SPAN) ?? []
  const boldChars = spans.reduce((sum, span) => sum + span.length - 4, 0)
  return {spans, boldRatio: markdown.length > 0 ? boldChars / markdown.length : 0}
}
